import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';
import prodPathReplace from 'shared/prod-path-rewrite';
import { useMediaQuery } from 'react-responsive';
import { screenMdMin } from 'styles/global_defaults/media-queries';
import { css } from '@emotion/react';
import {
  standardSpacing,
  threeQuartersSpacing,
  tripleSpacing,
} from 'styles/global_defaults/scaffolding';
import { white } from 'styles/global_defaults/colors';

type MentorPlusPromoProps = {
  isExpanded: boolean;
  dataQa: string;
};

const styles = (isExpanded: boolean) => css`
  height: ${isExpanded ? '74' : tripleSpacing}px;
  background: linear-gradient(
    45deg,
    rgba(255, 183, 124, 1) 0%,
    rgba(233, 95, 72, 1) 100%
  );
  color: ${white};

  .logo-mentor-plus {
    margin-right: ${isExpanded ? threeQuartersSpacing : 0}px;
  }
  .title-mentor-plus {
    font-weight: 800;
  }
`;

const MentorPlusPromo = ({
  isExpanded = false,
  dataQa,
}: MentorPlusPromoProps) => {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${screenMdMin}px)`,
  });

  const translationBase = t.MENTORING_PROGRAMS.IN_PRODUCT_PROMO;
  const title = translationBase.TITLE();
  const subtitle = translationBase.SUBTITLE();
  const ariaLabel = `${title} ${subtitle}`;

  return (
    <ClickableContainer
      id='mentor-plus-in-product-promo'
      css={styles((isExpanded || !isDesktop))}
      className='d-flex justify-content-center'
      aria-label={ariaLabel}
      data-qa={dataQa}
    >
      <img
        width={standardSpacing}
        height={standardSpacing}
        className='logo-mentor-plus'
        src={prodPathReplace('images/mentor-plus.svg')}
        alt={translationBase.LOGO_ALT()}
      />
      {(isExpanded || !isDesktop) && (
        <div className='py-4'>
          <div className='text-medium title-mentor-plus'>{title}</div>
          <div className='text-small'>{subtitle}</div>
        </div>
      )}
    </ClickableContainer>
  );
};
export default MentorPlusPromo;
